import {
  FormItem,
  Input,
  Form,
  Container,
  SubmitButton,
  Dropdown,
  Modal,
  Button,
  AutoComplete,
} from '../../components';
import { useModelsManagement } from './useModelsManagement';
import { modelTypesOptions } from './const';
import CreateModelForm from './createModelForm';
import { validateJSONforInput } from '../../utilities';
import DeleteModelForm from './deleteModelForm';
import type { ModelsManagementFormProps } from './useModelsManagement';

const ModelsManagementPage = () => {
  const {
    onChange,
    form,
    currentModels,
    formId,
    isModelCreating,
    isOpened,
    onClose,
    onOpen,
    setCurrentModels,
    handleUpdateModel,
    isModelUpdating,
    handleCreateModel,
    isModelDeleting,
    handleDeleteModel,
    openedDeleteModal,
    openDeleteModal,
    closeDeleteModal,
    allModels,
  } = useModelsManagement();

  return (
    <>
      <div className="p-4">
        <div className="flex flex-wrap justify-end gap-x-md">
          <Button
            label="Create Model"
            onClick={() => {
              setCurrentModels([]);
              onOpen();
            }}
            size="medium"
          />
          <Button
            label="Delete Model"
            type="contrast"
            onClick={() => {
              setCurrentModels([]);
              openDeleteModal();
            }}
            size="medium"
          />
        </div>
      </div>
      <Container>
        <Modal
          size="medium"
          open={isOpened}
          onClose={onClose}
          title="Create Model"
        >
          <CreateModelForm
            key={'new'}
            onCancel={onClose}
            saving={isModelCreating}
            onSave={handleCreateModel}
          />
        </Modal>
        <Modal
          size="small"
          open={openedDeleteModal}
          onClose={closeDeleteModal}
          title="Delete Model"
        >
          <DeleteModelForm
            key={'delete'}
            onCancel={closeDeleteModal}
            saving={isModelDeleting}
            onSave={handleDeleteModel}
            allModels={allModels}
          />
        </Modal>
        <Form
          key={String(formId || 'NEW')}
          onChange={onChange}
          initialValue={form as ModelsManagementFormProps}
        >
          <div className="flex gap-x-md">
            <FormItem<ModelsManagementFormProps>
              name="modelType"
              label=" Model Type"
              required
              inline={false}
            >
              <Dropdown
                placeholder="Select Model Type"
                options={modelTypesOptions}
              />
            </FormItem>
            <FormItem<ModelsManagementFormProps>
              name="modelId"
              label=" Model"
              required
              inline={false}
            >
              <AutoComplete
                placeholder="Select Model"
                options={currentModels}
              />
            </FormItem>
          </div>
          <FormItem<ModelsManagementFormProps>
            name="settings"
            label="Settings JSON"
            required
            validate={validateJSONforInput}
          >
            <Input multiline placeholder="Settings JSON" />
          </FormItem>
          <FormItem<ModelsManagementFormProps>
            name="settingsValidationSchema"
            label="Settings Validation Schema JSON"
            required
            validate={validateJSONforInput}
          >
            <Input multiline placeholder="Settings Validation Schema JSON" />
          </FormItem>
          <FormItem<ModelsManagementFormProps>
            name="uiSchema"
            label="UI Schema JSON"
            required
            validate={validateJSONforInput}
          >
            <Input multiline placeholder="Ui Schema JSON" />
          </FormItem>
          <div className="flex justify-end">
            <SubmitButton
              label="Update Model"
              size="medium"
              type="primary"
              disabled={isModelUpdating}
              onClick={handleUpdateModel}
            />
          </div>
        </Form>
      </Container>
    </>
  );
};

export default ModelsManagementPage;
